import React from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { usePrincipalContext } from "areas/account/components/PrincipalProvider";
import dayjs from 'dayjs';

export enum ErrorCodes {
    NotFound,
    GeneralError
}

interface ErrorProps {
    errorCode: ErrorCodes,
    alreadyLogged?: boolean
}

const Error = ({ errorCode, alreadyLogged = false }: ErrorProps) => {
    const { primaryPrincipal } = usePrincipalContext();
    let title = "Sorry, something went wrong";
    let description = "There was a problem showing the requested page.";
    switch (errorCode) {
        case ErrorCodes.NotFound:
            title = "Not found";
            description = "Sorry, we couldn't find that page";
            if (!alreadyLogged)
                console.error(`URL not found: ${document.location.href}.`); 
            break;
        default:
            if (!alreadyLogged)
                console.error(`Unknown error`);
    }

    return <Container>
        <Row>
            <Col md={4} sm={12}>
                <img src="/img/generic-error-mascot-standing.png" className="pull-right" alt="Decorative illustration" />
            </Col>
            <Col md={8} sm={12}>
                <div style={{ marginTop: "4em" }}>
                    <div style={{ padding: "35px 30px 10px", marginBottom: "1em", border: "1px solid #ddd", borderRadius: "4px", boxShadow: "1px 1px 1px rgba(0,0,0,.15)", maxWidth: "450px" }}>
                        <h3 className="text-danger">{title}</h3>

                        <p>{description}</p>
                        <br />

                        <p><strong>What should I do:</strong></p>
                        <ul>
                            <li>
                                You can try refreshing the page, the problem may be temporary
                            </li>
                            <li>
                                If you entered the url by hand, double check that it is correct
                            </li>
                            <li>
                                Nothing - we've been notified of the problem and will do our best to make sure it doesn't happen again!
                            </li>
                        </ul>
                        <br />

                        <p>
                            <strong>Some details our technical team will want:</strong>
                            <br />
                            User: {primaryPrincipal?.identity?.username}
                            <br />
                            Date &amp; time: {dayjs().format()}
                            <br />
                            Address: {document.location.href}
                        </p>
                    </div>
                </div>

            </Col>
        </Row>
    </Container>
}

export default Error;
